<template>
  <header>
    <v-app-bar
      color="white"
      elevation="1"
      style="position: fixed!important; top: 0; left: 0; z-index: 998"
    >
      <v-row no-gutters justify="space-around">
        <v-col align-self="center" align="start">
          <v-row no-gutters justify="start" align="center">
            <v-app-bar-nav-icon @click="drawer=!drawer"></v-app-bar-nav-icon>
            <router-link :to="{name: 'home'}">
              <v-img src="../assets/logo.png" class="ml-6" width="120"
                     :aspect-ratio="256/104"></v-img>
            </router-link>
          </v-row>
        </v-col>
        <v-spacer/>
        <v-col cols="5" align-self="center" align="center">
          <v-row no-gutters justify="space-around">
            <v-col v-for="(item, index) in subMenus" :key="index">
              <v-btn :href=item.url target="_blank" icon>
                <v-icon>{{ item.icon }}</v-icon>
                <span class="text-md-button text-lg-body-2 text-xl-subtitle-1" style="text-transform: none!important;">{{
                    item.name
                  }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-dialog
        v-model="regulationDialog.opened"
        persistent
        max-width="290"
      >
        <v-card>
          <v-card-title class="text-h5">
            規定について
          </v-card-title>
          <v-card-text>「全社共有\規程」に配置されています</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="regulationDialog.opened = false"
            >
              キャンセル
            </v-btn>
            <v-btn
              :href="regulationDialog.url"
              color="green darken-1"
              text
              @click="regulationDialog.opened = false"
            >
              GAIAに接続
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app-bar>

    <!-- ナビゲーション -->
    <v-navigation-drawer
      app
      dark
      v-model="drawer"
      bottom
      temporary
      style="z-index: 999"
    >
      <v-list nav>
        <div v-for="(item, index) in navigationItems"
             :key="index">
          <v-divider v-if="index > 0"/>
          <v-subheader v-if="item.category" class="text-caption font-weight-bold">
            <v-chip outlined small color="green">{{ item.category }}</v-chip>
          </v-subheader>
          <v-list-item
            v-for="content in item.items"
            :key="content.title"
            :to="content.to"
          >
            <v-list-item-content>
              <v-list-item-title> {{ content.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>
  </header>
</template>

<script>
import { Logger } from 'aws-amplify';

const logger = new Logger('header');

export default {
  name: 'HeaderView',
  data() {
    return {
      navigationItems: [
        {
          category: '',
          items: [
            { title: 'ホーム', to: { name: 'home' } },
            { title: 'お知らせ一覧', to: { name: 'notificationList' } },
          ],
        },
        {
          category: '申請 / マニュアル',
          items: [
            { title: '申請書・マニュアル', to: { name: 'manual' } },
            { title: 'UI UX', to: { name: 'uiUx' } },
            { title: 'MOTPhone設定更新方法', to: { name: 'motPhone' } },
            { title: '制度・福利厚生', to: { name: 'welfareList' } },
          ],
        },
        {
          category: '連絡先',
          items: [
            { title: 'レポートライン一覧表', to: { name: 'telephoneLine' } },
            { title: 'MOTPhone内線・外線一覧表', to: { name: 'telephoneOutline' } },
            { title: '社用携帯電話番号一覧', to: { name: 'cellPhoneList' } },
            { title: '緊急連絡体制', to: { name: 'emergencyContact' } },
          ],
        },
        {
          category: 'ルール',
          items: [
            { title: '行動指針', to: { name: 'guidelinesForAction' } },
            { title: '社用携帯に関するお知らせ', to: { name: 'cellPhone' } },
            { title: 'オフィス内設備ルール', to: { name: 'rule' } },
            { title: '会社携帯の盗難・紛失時', to: { name: 'phoneLost' } },
          ],
        },

      ],
      subMenus: [
        { url: 'https://medrt.co.jp/', icon: 'mdi-domain', name: 'ホームページ' },
        { url: 'https://mrt.netsourcing.jp/system/login.php', icon: 'mdi-archive-clock-outline', name: 'SMART LINK' },
        { url: 'https://rsopera.rakurakuseisan.jp/xnBHV76FqAa/', icon: 'mdi-file-document-edit-outline', name: '楽楽精算' },
        { url: 'https://the-board.jp/user/login', icon: 'mdi-content-paste', name: 'board' },
      ],
      // 規程ダイアログ
      regulationDialog: {
        opened: false,
        // GAIAの接続先
        url: 'smb://gaia',
      },

      // null初期値でデスクトップはデフォルトOpen, モバイルでClose
      drawer: null,
    };
  },
  methods: {
    /**
     * 規程クリック
     */
    clickedRegulation() {
      logger.info('clickedRegulation');
      this.regulationDialog.opened = true;
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.theme--light.v-divider {
  border-color: #0095D9;
}

.home__btn.theme--light.v-btn--active::before {
  display: none;
}

</style>
